import {Component, Input} from '@angular/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'scitis-status-event-signal-configuration-preview',
    templateUrl: './status-event-signal-configuration-preview.component.html',
    styleUrls: ['./status-event-signal-configuration-preview.component.scss'],
    standalone: false
})
export class StatusEventSignalConfigurationPreviewComponent {

  @Input()
  htmlDetails: string = '';

  constructor(private activeModal: NgbActiveModal) {
  }

  onClose() {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }
}
